/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement } from 'react'
import { Helmet } from 'react-helmet'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import amex from '../../assets/icons/amex.svg'
import brazil from '../../assets/icons/brazil.svg'
import chat from '../../assets/icons/chat.svg'
import elo from '../../assets/icons/elo.svg'
import facebook from '../../assets/icons/facebook.svg'
import instagram from '../../assets/icons/instagram.svg'
import linkedin from '../../assets/icons/linkedin.svg'
import mail from '../../assets/icons/mail.svg'
import mastercard from '../../assets/icons/mastercard.svg'
import usa from '../../assets/icons/usa.svg'
import visa from '../../assets/icons/visa.svg'
import youtube from '../../assets/icons/youtube.svg'
import logo from '../../assets/logo-white.svg'
import { RoutesEnum } from '../../utils/routesEnum'
import { MD } from '../../utils/screenSizes'
import ContactCard from '../contactCard'
import { Container, Inside } from './styles'
declare global {
  interface Window {
    zE:any
  }
}

const Info: FC = (): ReactElement => (
  <div className='info'>
    <img src={logo} alt='CalcLab' className='logo' />
    CalcLab Desenvolvimento De Programas de Computador LTDA
    <br />
    <br />
    CNPJ: 37.098.104/0001-90
  </div>
)

const Social: FC = (): ReactElement => (
  <div className='social'>
    <span>
      Acompanhe nas redes
    </span>
    <a href='/pt-br'>
      <img src={youtube} alt='Youtube' />
    </a>
    <a href='/pt-br'>
      <img src={linkedin} alt='LinkedIn' />
    </a>
    <a href='/pt-br'>
      <img src={facebook} alt='Facebook' />
    </a>
    <a href='/pt-br'>
      <img src={instagram} alt='Instagram' />
    </a>
  </div>
)

const Nav: FC = (): ReactElement => (
  <nav>
    <ul>
      <li><a href='/'><b>CalcLab</b></a></li>
      <li><a href='/#how-it-works'>Como funciona?</a></li>
      <li><a href='/#testimony'>Depoimentos</a></li>
      <li><a href='/#faq'>FAQ</a></li>
      <li><a href='/#plans'>Preços</a></li>
    </ul>
    <ul>
      <li><a href='/'><b>Ajuda</b></a></li>
      <li><Link to={RoutesEnum.REGISTER}>Cadastre-se</Link></li>
      <li><a href='/'>Política de cancelamento</a></li>
      <li><a href='/'>Termos de Uso</a></li>
    </ul>
  </nav>
)

const Contact: FC = (): ReactElement => (
  <div className='contact'>
    <Helmet>
      <script id='ze-snippet' src='https://static.zdassets.com/ekr/snippet.js?key=8064e4e2-8481-4b95-a886-0b3a37f48a1e' />
    </Helmet>
    <ContactCard
      icon={mail}
      href='mailto:contato@calclab.com.br'
      title='Atendimento:'
      subtitle='contato@calclab.com.br'
    />
    <ContactCard
      isZendesk
      icon={chat}
      onClick={() => window.zE(() => window.zE.activate())}
      title='Ajuda?'
      subtitle='Entre em contato conoso'
    />
  </div>
)

export const AcceptCreditCards: FC = (): ReactElement => (
  <div className='accept'>
    <span>
      Aceitamos:
    </span>
    <img src={mastercard} alt='visa' />
    <img src={visa} alt='visa' />
    <img src={elo} alt='elo' />
    <img src={amex} alt='amex' />
  </div>
)

const Flags: FC = (): ReactElement => (
  <div className='flags'>
    <a href='?lang=pt-br'>
      <img src={brazil} alt='Português' />
    </a>
    <a href='?lang=en'>
      <img src={usa} alt='English' />
    </a>
  </div>
)

const Footer: FC = (): ReactElement => {
  const isTablet = useMediaQuery({ query: `(max-width: ${MD})` })

  return (
    <Container>
      <Inside>
        <div className='top'>
          {isTablet
            ? (
              <>
                <Info />
                <Contact />
              </>
            )
            : (
              <>
                <Flags />
                <Social />
              </>
            )}
        </div>
        <hr />
        <div className='footer'>
          {isTablet
            ? (
              <>
                <Nav />
                <Social />
                <AcceptCreditCards />
              </>
            )
            : (
              <>
                <Info />
                <Nav />
                <Contact />
              </>
            )}
        </div>
        <hr />
        <div className='bottom'>
          <div>
            Propriedade intelectual CalcLab 2021 - todos os direitos reservados
          </div>
          {isTablet ? <Flags /> : <AcceptCreditCards />}
        </div>
      </Inside>
    </Container>
  )
}

export default Footer
